export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === '/protocol/sdk-list') {
    const event = useRequestEvent()
    const isIOS = event.context.device.isIOS
    return navigateTo(
      `/ky-agreement?luban8Cid=${
        isIOS ? 'KyIosSdkList' : 'KyAndroidSdkList'
      }&bgColor=#fff`
    )
  }
})
